<div class="auth-main">
    <div class="auth-block">
        <div class="auth-wrapper">
            <h1><img src="../../../assets/img/iclinic-azul.svg" alt="iClinic Pay" class="logo"></h1>
            <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" class="form-horizontal">
                <span class="group-title">
                    Troca de Senha
                </span>
                <div class="input-group forget-password">
                    <input formControlName="old_password" type="password" class="form-control" name="old_password" placeholder="Senha antiga" aria-describedby="basic-addon1">
                    <div class="show-password" (click)="togglePasswordVisiblity('old_password');">
                        <i class="fa fa-eye" [class.shown]="passwordShown['old_password']"></i>
                    </div>
                </div>
                <div *ngIf="formErrors.old_password" class="alert-danger error-msg black">
                    {{ formErrors.old_password }}
                </div>
                <div class="input-group forget-password">
                    <input formControlName="password" type="password" class="form-control" name="password" placeholder="Nova Senha" aria-describedby="basic-addon1">
                    <div class="show-password" (click)="togglePasswordVisiblity('password');">
                        <i class="fa fa-eye" [class.shown]="passwordShown['password']"></i>
                    </div>
                </div>
                <div *ngIf="formErrors.password" class="alert-danger error-msg black">
                    {{ formErrors.password }}
                </div>
                <div class="input-group forget-password">
                    <input formControlName="password_confirmation" type="password" class="form-control" name="password_confirmation" placeholder="Confirmação da nova senha"
                        aria-describedby="basic-addon1">
                        <div class="show-password" (click)="togglePasswordVisiblity('password_confirmation');">
                            <i class="fa fa-eye" [class.shown]="passwordShown['password_confirmation']"></i>
                        </div>
                </div>
                <div *ngIf="formErrors.password_confirmation" class="alert-danger error-msg black">
                    {{ formErrors.password_confirmation }}
                </div>
                <div class="form-group row">
                    <div class="col-sm-12">
                        <div class="alert alert-info" *ngFor="let msg of success">
                            {{ msg }}
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12">
                        <div class="alert alert-danger" *ngIf="errors">
                            {{ errors}}
                        </div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <loading-button [is-visible]="showLoading" [is-user]="isUser" text="Enviar"></loading-button>
                </div>
            </form>
        </div>
    </div>
</div>